// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".headerLine[data-v-5a5943a0] {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: space-between;\n}\n.center[data-v-5a5943a0] {\n  height: calc(100% - 168px);\n}\n.imageP p[data-v-5a5943a0] {\n  margin: 0 0 0 10px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
